export const getDealPotentialImpression = () => ({
  dealImpression: {
    backgroundColor: 'white',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    padding: 10,
    width: 400,
    height: 'fit-content',
    marginBottom: 20,
    '&.panel-mode': {
      height: 'unset',
      boxShadow: 'none',
    },
    '& .deal-seller': {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '15px',
    },
    '& .deal-warning': {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '15px',
      '& .deleted-text': {
        color: '#A80000',
      },
    },
    '& .desc': {
      fontSize: '12px',
      fontWeight: 'bold',
    },
    '& .impression': {
      fontSize: '28px',
      fontWeight: 'bold',
    },
    '& .deal-impression': {
      marginBottom: '20px',
    },
    '& .broadMeter': {
      backgroundColor: '#004578 !important',
      height: '24px !important',
      top: '8px !important',
    },
    '& .specificMeter': {
      height: '24px !important',
      top: '8px !important',
    },
  },
});
